import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { ClientesService } from 'src/app/services/clientes.service';
import { GruposService } from 'src/app/services/grupos.service';

@Component({
  selector: 'app-registro',
  templateUrl: './registro.component.html',
  styleUrls: ['./registro.component.scss']
})
export class RegistroComponent implements OnInit {
  formulario2;
  grupoid;
  data;
  nombreGrupo;
  grupo;
  respuestaDetalleGrupo:any;
  respuestaAgregarCliente:any;
  public isChecked = false;

  constructor(private actRoute: ActivatedRoute, private _getDetalleGrupo: GruposService,
    private _agregarCliente: ClientesService, public iziToast:Ng2IzitoastService) { }

  ngOnInit(): void {

    this.actRoute.paramMap.subscribe(params => {
      this.grupoid = this.actRoute.snapshot.paramMap.get('grupo');
      if ( this.grupoid){
        this.getDetalleGrupo(this.grupoid);
      }
      
    });

    this.formulario2 = {
      nombre:'',
      apellidos:'',
      celular:'',
      email:'',
    }
  }

  agregarUsuarioGrupo(grupoid){

    if (this.formulario2.password2 != this.formulario2.password){
      this.iziToast.show(
        {
            title: 'Las contraseñas no coinciden.',
            titleColor: '#f8f8ff',
            color: '#DC143C',
            position: 'topRight',
            closeOnEscape: true,
        });
      return;
    }

    this.data = {
      'grupo': grupoid,
      'first_name': this.formulario2.nombre,
      'last_name': this.formulario2.apellidos,
      'apellido_materno': this.formulario2.apellido_materno,
      'celular': this.formulario2.celular,
      'email': this.formulario2.email,
      'password': this.formulario2.password,
    }

    console.log(this.data);
    if (this.formulario2.celular != ''){
      if (this.isChecked == true){
        this._agregarCliente.agregarClienteGrupo(this.data).subscribe(
          data => {
            this.respuestaAgregarCliente = data;
            if(this.respuestaAgregarCliente.success){
              this.iziToast.show(
                {
                    title: 'Se ha agregado el cliente correctamente.',
                    titleColor: '#f8f8ff',
                    color: '#4CAF50',
                    position: 'topRight',
                    closeOnEscape: true,
                });
              this.formulario2.nombre = '';
              this.formulario2.apellidos = '';
              this.formulario2.celular = '';
              this.formulario2.email = '';
            }else {
              this.iziToast.show(
                {
                    title: this.respuestaAgregarCliente.error,
                    titleColor: '#ffffff',
                    color: '#CA0B00',
                    position: 'topRight',
                    closeOnEscape: true,
                });
            }
          }, error => console.error(error));
        }else{
          this.iziToast.show(
            {
                title: 'Debes aceptar los términos y condiciones',
                titleColor: '#f8f8ff',
                color: '#DC143C',
                position: 'topRight',
                closeOnEscape: true,
            });
        }
      }else{
        this.iziToast.show(
          {
              title: 'Por favor agrega un número telefónico.',
              titleColor: '#f8f8ff',
              color: '#DC143C',
              position: 'topRight',
              closeOnEscape: true,
          });
      } 

  }

  getDetalleGrupo(grupoid){
    this.data = {
      'grupo':grupoid,
    }
    this._getDetalleGrupo.getDetalleGrupo(this.data).subscribe(
      data => {
        this.respuestaDetalleGrupo = data;
        if(this.respuestaDetalleGrupo.success){
          this.grupo = this.respuestaDetalleGrupo.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

}
